module.exports = require("memdown");


//////////////////
// WEBPACK FOOTER
// external "memdown"
// module id = 43
// module chunks = 0